(ns app.strive-forms.question-components
  (:require [app.strive-forms.defaults :refer [default-values]]
            [app.strive-forms.helper-functions :refer [get-font-for-multi-question-page-title
                                                       get-question-title-in-html]]
            [app.strive-forms.styles :refer [letter-checkbox-input-style
                                             letter-checkbox-label-style
                                             letter-checkbox-style question-field-style question-title-area-style]]
            [day8.re-frame-10x.components.re-com :refer [v-box h-box]]))


(defn letter-checkbox [{:keys [letter fill-color neutral-color condition-to-fill-color text-color border-color-for-letter]}]
  [:div {:class (letter-checkbox-style {:background-color (if condition-to-fill-color fill-color neutral-color)
                                        :text-color (when condition-to-fill-color text-color)
                                        :border-color border-color-for-letter})
         :on-click (fn [^js/Event e]
                     (.preventDefault e))}
   [:input {:type "checkbox" :id "myCheckbox" :class (letter-checkbox-input-style)}]
   [:label {:for "myCheckbox" :class (letter-checkbox-label-style)} letter]])

(defn question-title [{:keys [font-family font-color font-size text-align selected-language field hidden-fields display-fields title-component-width question-title-height]}]
  [:div {:class (question-field-style font-family font-color font-size text-align title-component-width question-title-height (:is_required field))
         :dangerouslySetInnerHTML {:__html (get-question-title-in-html ((keyword selected-language) (:field_name_html field))
                                                                             hidden-fields display-fields selected-language)}}])



(defn question-title-themes-hierarchy [{:keys [field selected-language theme-data hidden-fields display-fields is-multi-question? language-direction]}]
  (let [title-component-width (if is-multi-question?
                                (:width-in-multi (:title default-values))
                                (:width (:title default-values)))
        font-family (or
                     (:font_family (:field_style field) (:font theme-data))
                     (:font-family (:title default-values)))
        font-size (str
                   (if is-multi-question?
                     (get-font-for-multi-question-page-title {:title-multiplied-by (:fraction-of-title (:title default-values))})
                     (:font_size (:field_style field) (:font-size (:title default-values))))
                   "px")
        font-color (or
                    (:color (:field_style field) (:questions_color theme-data))
                    (:color (:title default-values)))
        text-align (if is-multi-question?
                     (if (= "RTL" language-direction)
                       (:align-in-multi-rtl (:title default-values))
                       (:align-in-multi (:title default-values)))
                     (:align (:field_style field) (:align (:title default-values))))
        question-title-height (if (= "welcome_screen" (:type field)) "100%" "200px")]

    [question-title {:font-family font-family :font-color font-color :font-size font-size
                     :text-align text-align :selected-language selected-language :field field
                     :hidden-fields hidden-fields :display-fields display-fields :title-component-width title-component-width
                     :question-title-height question-title-height}]))

(defn question-title-area [{:keys [field selected-language theme-data hidden-fields display-fields is-multi-question? language-direction]}]
  [v-box
   :class (question-title-area-style)
   :align :center
   :width "100%"
   :children [[question-title-themes-hierarchy {:field field :selected-language selected-language :theme-data theme-data
                                                :hidden-fields hidden-fields :display-fields display-fields
                                                :is-multi-question? is-multi-question? :language-direction language-direction}]]])